export const DEFAULT_INITIAL_PAGE = 1;
export const DEFAULT_DOCUMENTS_PER_PAGE = 10;
